<script>
import {useBalanceStore} from "@/stores/Balance.js";
import useSharedData from "@/use/SharedData.js";
import useSharedMethod from "@/use/SharedMethod.js";
import useTools from "@/use/Tools.js";
import {onMounted, watch} from "vue";
import {useSecurityStore} from "@/stores/Security.js";
import axios from "axios";

export default {
    setup() {
        const {
            total,
            loading,
            filter,
        } = useSharedData();

        const {transformFilterValues} = useSharedMethod();

        const {$i18n, $router} = useTools();

        const balanceStore = useBalanceStore();
        const securityStore = useSecurityStore();

        const headers = [
            {
                text: "...",
                align: "left",
                sortable: false,
                value: "action",
                width: "0%",
            },
            {
                text: $i18n.t("common.label"),
                align: "left",
                sortable: true,
                value: "name",
                width: "0%",
            },
            {
                text: $i18n.t("balance.init_value"),
                align: "left",
                sortable: true,
                value: "defaultInitValue",
                width: "0%",
            },
            {
                text: $i18n.t("balance.unity"),
                align: "left",
                sortable: true,
                value: "unite",
            },
        ];

        const actions = [
            {
                title: $i18n.t("common.edit"),
                icon: 'mdi-pencil-box-multiple',
                color: 'orange',
                access: () => securityStore.authorities['UPDATE_ABSENCE_REQUEST_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'balances.edit', params: { id: item.id }})
                },
            },
            {
                title: $i18n.t("common.delete"),
                icon: 'mdi-trash-can',
                color: 'red',
                access: () => securityStore.authorities['UPDATE_ABSENCE_REQUEST_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'balances.delete', params: { id: item.id }})
                },
            },
        ];

        function findAll() {
            loading.value = true;
            axios.get('/balances', {params: transformFilterValues(filter.value)}).then((response) => {
                balanceStore.setBalances(response.data);
                total.value = response.data.length;
            }).finally(() => {
                loading.value = false;
            });
        }

        function view(item) {
            $router.push({name: "balances.view", params: {id: item.id}});
        }

        onMounted(() => findAll());

        watch(() => filter, () => {
            findAll();
        }, {deep: true, immediate: true});

        return {
            balanceStore,
            securityStore,
            headers,
            actions,
            total,
            loading,
            filter,
            view,
            findAll,
        };
    },
};
</script>

<template>
    <div>
        <w-app
            :title="$t('module.balances')"
            :total="total"
        >
            <template v-slot:rightToolbar>
                <w-btn-reload
                    :loading="loading"
                    @press="findAll"
                />
                <w-btn-add
                    :show="securityStore.authorities['UPDATE_ABSENCE_REQUEST_PARAM']"
                    @press="$router.push({ name: 'balances.add' })"
                />
            </template>

            <template v-slot:content>
                <w-data-table
                    :headers="headers"
                    :actions="actions"
                    :items="balanceStore.balances"
                    :total="total"
                    :loading="loading"
                    sort-by="name"
                    @rowDbClick="view"
                >
                    <template v-slot:[`item.name`]="{ item }">
                        <w-inline-text bold :text="item.name"/>
                    </template>
                    <template v-slot:[`item.defaultInitValue`]="{ item }">
                        <w-inline-text :text="item.defaultInitValue"/>
                    </template>
                    <template v-slot:[`item.unite`]="{ item }">
                        <w-inline-text :text="$t(`balance.${item.unite}`)"/>
                    </template>
                </w-data-table>
            </template>
        </w-app>
        <router-view/>
    </div>
</template>
